import type { APIRequestQueryParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type Integration = APIResponse<'/api/v4/integrations'>[number];
export type IntegrationsQuery = APIRequestQueryParams<'/api/v4/integrations'>;

export const fetchIntegrations = (params: IntegrationsQuery) =>
  get<Integration[]>('/v4/integrations', { params });
